import { useState } from 'react';
import { Modal } from 'react-bootstrap'
import { CropProfileImage } from './CropImage/CropImageModal';
import { WebCamModal } from './WebCam/CameraModal';

interface ModalProps {
  showModal: boolean;
  handleCloseModal: () => void;
  onImageSelected: (file: File) => void;
}

const ModalImgInput: React.FC<ModalProps> = ({ showModal, handleCloseModal, onImageSelected }) => {
  const [selectedImageFile, setSelectedImageFile] = useState<File | null>(null);
  const [showCropModal, setShowCropModal] = useState(false);
  const [isCameraOpen, setIsCameraOpen] = useState(false);

  const onFileChanged = (file: File) => {
    handleCloseModal();
    setSelectedImageFile(file);
    setShowCropModal(true);
  };

  const openCameraR = () => {
    handleCloseModal();
    setIsCameraOpen(true);
  }

  const handleCameraCapture = (file: File) => {
    setSelectedImageFile(file);
    setShowCropModal(true);
  };

  const handleImageCropped = (file: File) => {
    setSelectedImageFile(file);
    onImageSelected(file);
  };

  return (
    <>
      <Modal
        backdrop={false}
        centered
        show={showModal}
        onHide={handleCloseModal}
      >
        <Modal.Body>
          Only one person per picture. No text or filters.
          <div className="mt-3">
            {/* Add Camera Functionbality Later */}
            <button className="link btns btnMO justify-content-center d-flex  align-content-center  col-12 mt-2 mb-2" onClick={openCameraR}>
              Camera
            </button>
            <label
              className="link btns btnMO justify-content-center d-flex  align-content-center  col-12 mt-2 "
              style={{ cursor: "pointer" }}
            >
              <input
                type="file"
                id="fileInput"
                accept="image/*"
                style={{ display: "none" }}
                className="col-12 mt-2"
                onChange={(e) => e.target.files ? onFileChanged(e.target.files[0]) : undefined}
              />
              Gallery
            </label>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="link btns btnMO justify-content-center d-flex  align-content-center  col-12  mb-2"
            onClick={handleCloseModal}
          >
            Cancel
          </button>
        </Modal.Footer>
      </Modal>

      {isCameraOpen && <WebCamModal isOpen={isCameraOpen} setIsOpen={setIsCameraOpen} onCapture={handleCameraCapture} />}

      {/* Image cropping Modal */}
      {showCropModal && <CropProfileImage imageFile={selectedImageFile} showCropModal={showCropModal} setShowCropModal={setShowCropModal}
        onImageCropped={handleImageCropped}
      />}
    </>
  )
}

export default ModalImgInput
